<template>
    <div id="app">
        <router-view
            :list-of-pitchers="listOfPitchers"
            :list-of-games="listOfGames"
            :list-of-teams="listOfTeams"
            :global-user-account="globalUserAccount"
            @compelete-local-storage="completeLocalStorage"
        />
        <ToolTips
            v-if="!!toolTip"
            :list-of-teams="listOfTeams"
        />
        <video-modal-wrapper :list-of-teams="listOfTeams" />
        <div
            v-if="modal3d.display"
            class="modal3d"
        >
            <three
                :vs-data-clicked-ball="modal3d"
                :init-mode="modal3d.mode"
                @modal3d-off="modal3d.display=false"
            />
        </div>
        <!-- メッセージモーダル -->
        <message-modal
            v-show="messageModalShow"
            :message="message"
            @message-modal-off="messageModalOff"
        />
    </div>
</template>

<script>
import '@/reset.css'
import '@/default.css'
import '@/default_sp.css'
import '@/iconFont.css'
import '@/iconImgSp.css'
import ToolTips from "@/components/utility/ToolTips.vue"
import {mapGetters} from "vuex"
import API from "@/api"
import common from "@/common"
import Three from "@/components/3d.vue"
import MessageModal from "@/components/MessageModal.vue"

export default {
    name: 'App',
    components: {
        MessageModal,
        Three,
        ToolTips,
        VideoModalWrapper: () => import("./components/VideoModalWrapper.vue")
    },
    data() {
        let listOfPitchers = this.$ls.get('listOfMyTeamPitchers', {})
        let listOfGames = this.$ls.get('listOfMyTeamGames', [])
        let listOfTeams = this.$ls.get('listOfTeams', {})
        let globalUserAccount = this.$ls.get('userAccount', {})
        let currentPitchingNum = this.$ls.get('currentPitchingNum', 0)

        return {
            listOfPitchers,
            listOfGames,
            listOfTeams,
            globalUserAccount,
            pitchingActiveTab: 0,
            currentPitchingNum,
            modal3d: {
                display: false,
                ballId: '',
                allData: {},
                mode: 'atBat'
            },
            message: '',
            messageModalShow: false
        }
    },
    computed: {
        ...mapGetters(['toolTip','listOfStadiums'])
    },
    mounted() {
        this.completeLocalStorage()
    },
    created() {
        this.$router.afterEach(() => {
            this.messageModalOff()
            this.$store.commit('setToolTip',null)
        })
        let globalPitcherData = this.$ls.get('globalPitcherData', null)
        if (globalPitcherData) {
            this.$store.commit('setGlobalPitcherData', globalPitcherData)
        }

        let globalComparisonPitcherData = this.$ls.get('globalComparisonPitcherData', null)
        if (globalComparisonPitcherData) {
            this.$store.commit('setGlobalComparisonPitcherData', globalComparisonPitcherData)
        }

        // 基準投手
        this.$root.$on('setPitcherData', (globalPitcherData) => {
            this.$store.commit('setGlobalPitcherData', globalPitcherData)
        })
        this.$root.$on('setComparisonPitcherData', (globalComparisonPitcherData) => {
            this.$store.commit('setGlobalComparisonPitcherData', globalComparisonPitcherData)
        })
        this.$root.$on('remove-comparison-pitcher-data', () => {
            this.$store.commit('setGlobalComparisonPitcherData', null)
        })
        // 神事先生コンパネ用基準投手
        this.$root.$on('setPitcherDataJinji', (globalPitcherDataJinji) => {
            this.globalPitcherDataJinji = globalPitcherDataJinji
        })
        // 神事先生コンパネ用比較投手
        this.$root.$on('setComparisonPitcherDataJinji', (globalComparisonPitcherDataJinji) => {
            this.globalComparisonPitcherDataJinji = globalComparisonPitcherDataJinji
        })
        this.$root.$on('remove-comparison-pitcher-data-jinji', () => {
            this.globalComparisonPitcherDataJinji = null
        })
        this.$root.$on('modal3dOn', this.modal3dOn)

        this.$root.$on('messageModalOn', this.messageModalOn)
        this.$root.$on('messageModalOff', this.messageModalOff)
        this.$root.$on('completeLocalStorage', this.completeLocalStorage)

        // デバイス判定
        if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
            document.body.classList.add('platform-ipad')
        } else {
            document.body.classList.add('platform-pc')
        }
        if (window.navigator.standalone) {
            document.body.classList.add('standalone')
        } else {
            if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
                if (window.innerHeight === 704) {
                    document.body.classList.remove('tab672')
                    document.body.classList.add('tab704')
                } else if (window.innerHeight === 672) {
                    document.body.classList.remove('tab704')
                    document.body.classList.add('tab672')
                }
            }
            window.addEventListener('resize',  this.resize, false)
        }
    },
    methods: {
        messageModalOn (message, time = 2000) {
            this.message = message
            this.messageModalShow = true
            setTimeout(this.messageModalOff, time)
            console.log('messageModalOn', message, time)
        },
        messageModalOff () {
            this.messageModalShow = false
        },
        modal3dOn (id, allData, mode) {
            console.log('modal3dOn', id, allData)
            let selectedBallInning = allData.inning.toString()
            let selectedBallPaofinning = allData.paofinning.toString()
            const batter = allData.Batter ? allData.Batter.identifier + '@' + allData.Batter.team_id : allData.pitchingdata.BatterId + '@' + allData.pitchingdata.BatterTeam

            const query = {
                batter: batter,
                game_id: allData.game_id,
                he_first: true
            }
            API.PITCHES.getIndex(query,
                (json) => {
                    const array = json.filter(d=>d.inning === selectedBallInning && d.paofinning === selectedBallPaofinning).map((d,i)=>{
                        if (d.pitchingdata) {
                            if (d.pitchingdata.TaggedPitchType === 'FourSeamFastball') {
                                d.pitchingdata.TaggedPitchType = 'Fastball'
                            }
                            if (d.pitchingdata.TaggedPitchType === 'OneSeamFastball') {
                                d.pitchingdata.TaggedPitchType = 'TwoSeamFastball'
                            }
                            if (['FoulBallNotFieldable','FoulBallFieldable'].includes(d.pitchingdata.PitchCall)) {
                                d.pitchingdata.PitchCall = 'FoulBall'
                            }
                        }
                        d.pitchno = i + 1
                        d.pitchofpa = Number(d.pitchofpa)
                        return d
                    }).sortBy('pitchofpa')
                    this.modal3d = {
                        display: true,
                        ballId: id,
                        allData: this.$copy(allData),
                        atBatDataList: array,
                        mode: mode
                    }
                },
                (json) => {
                    console.log('getAllPitchesAPI取得失敗', json)
                    common.LOG('ERROR', '打撃データ詳細', 'getAllPitches', JSON.stringify(json))
                })
        },
        completeLocalStorage () {
            let listOfPitchers = this.$ls.get('listOfMyTeamPitchers')
            if (listOfPitchers !== null) {
                this.listOfPitchers = listOfPitchers
            }
            let listOfGames = this.$ls.get('listOfMyTeamGames')
            if (listOfGames !== null) {
                this.listOfGames = listOfGames
            }
            let listOfTeams = this.$ls.get('listOfTeams')
            if (listOfTeams !== null) {
                this.listOfTeams = listOfTeams
                this.$store.commit('setTeamsList', listOfTeams)
            }
            let listOfStadiums = this.$ls.get('listOfStadiums', {})
            if (listOfStadiums !== null) {
                this.$store.commit('setStadiums', listOfStadiums)
            }
            let globalUserAccount = this.$ls.get('userAccount')
            if (globalUserAccount !== null) {
                this.globalUserAccount = globalUserAccount
                this.$store.commit('setUserAccount', globalUserAccount)
            }
        },
        resize () {
            if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
                if (window.innerHeight === 704) {
                    document.body.classList.remove('tab672')
                    document.body.classList.add('tab704')
                } else if (window.innerHeight === 672) {
                    document.body.classList.remove('tab704')
                    document.body.classList.add('tab672')
                }
            }
        }
    },
    destroy () {
        window.removeEventListener('resize',  this.resize, false)
        this.$root.$off('setPitcherData', (globalPitcherData) => {
            this.globalPitcherData = globalPitcherData
        })
        this.$root.$off('setComparisonPitcherData', (globalComparisonPitcherData) => {
            this.globalComparisonPitcherData = globalComparisonPitcherData
        })
        this.$root.$off('remove-comparison-pitcher-data', () => {
            this.globalComparisonPitcherData = null
        })
        // 神事先生コンパネ用基準投手
        this.$root.$off('setPitcherDataJinji', (globalPitcherDataJinji) => {
            this.globalPitcherDataJinji = globalPitcherDataJinji
        })
        // 神事先生コンパネ用比較投手
        this.$root.$off('setComparisonPitcherDataJinji', (globalComparisonPitcherDataJinji) => {
            this.globalComparisonPitcherDataJinji = globalComparisonPitcherDataJinji
        })
        this.$root.$off('remove-comparison-pitcher-data-jinji', () => {
            this.globalComparisonPitcherDataJinji = null
        })
        this.$root.$off('modal3dOn', this.modal3dOn)
        this.$root.$off('messageModalOn', this.messageModalOn)
        this.$root.$off('messageModalOff', this.messageModalOff)
    }
}
</script>
